export default "__VITE_ASSET__f07f199e__"